
import React, {Component} from "react";
import OrderDetail from './Detail';
import { Drawer } from "ui/Drawer";


export default class OrderOpenDetail extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isDrawerOpen: false
    };
  }

  toggleDrawer = () => {
    this.setState({
      isDrawerOpen: !this.state.isDrawerOpen,
    })
  };

  closeDrawer = () => {
    const { onClose } = this.props;
    this.setState({
      isDrawerOpen: false,
    })
    if (onClose !== undefined) {
      onClose();
    }
  }

  render() {
    const { orderId } = this.props;
    return (
      <>
        {this.props.children(this.toggleDrawer)}
        <Drawer
          open={this.state.isDrawerOpen}
          onClose={() => this.closeDrawer()}
          width={'450px'}
          disableEscapeKeyDown={true}
        >
          <OrderDetail id={orderId} onClose={this.toggleDrawer} />
        </Drawer>
      </>
    );
  }
}